import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Result } from '../../models/Result/Result';
import { AppConfigService } from '../app-config/app-config.service';
import { OeHttpClientService } from '../oe-http-client/oe-http-client.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {

  private readonly apiUrl: string;

  constructor(private readonly appConfigService: AppConfigService,
              private readonly httpClient: OeHttpClientService)
  {
    this.apiUrl = appConfigService.getData('apiEndpoint') + '/featureflag/';
  }

  getFeatureFlagApi(flag: string): Promise<Result<boolean>> {
    return this.httpClient.get(`${this.apiUrl}${flag}`).toPromise();
  }
}
